<template lang="pug">
div
  section
    .grid.is-desktop-6
      .column.u-mt-md(v-for="service,idx in $t('services')")
        AppLink(:to="service.url" :title="$t('service.title')"  )
          AppTitle.u-mb-xs.h2(:title="service.title" tag="h1" v-if="idx == 1")
          AppTitle.u-mb-xs(:title="service.title" tag="h2" v-else)
        p.u-text-lg.u-mb-xs {{service.desc}}
        .services-meta
          div(v-for="(item,key) in service.subs") #[AppLink(:to="item.url ? item.url :`/services/${key}`"  :title="item.title" )  {{item.title}} ]





  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('exploreMantra')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/industries" :title="$t('exploreIndustries')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreIndustries')}}
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/solutions" :title="$t('exploreSolutions')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreSolutions')}}


  section.u-mt-sm.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")
</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<style lang="stylus">
.services-meta
  display: flex
  flex-wrap: wrap
  margin-left: -20px
  margin-right: -20px

  >*
    margin: 10px 20px

  a
    text-decoration: underline
</style>

<i18n>
{
  "en": {
    "pageTitle":"Baianat services",
    "pageDesc":"Helping businesses through our capabilities that include  branding, interaction, type design, business, animation, development, product design and technology.",
    "mantra":"We help businesses grow |and succeed digitally.",
    "services":{
      "business":{
        "title":"Business",
        "desc":"Establish a solid foundation for your business, overcome risks and strategize your marketing efforts.",
        "url":"/services/business",
        "subs":{
          "business-model-innovation":{
            "title":"Business model innovation"
          },
          "growth":{
            "title":"Growth"
          },
          "organization-design":{
            "title":"Organization design"
          },
          "conversion-rate-optimization":{
            "title":"Conversion rate optimization"
          },
          "marketing":{
            "title":"Marketing"
          },
          "social-media":{
            "title":"Social media"
          },
          "content-creation":{
            "title":"Content creation"
          },
          "search-engine-optimization":{
            "title":"Search engine optimization"
          },
          "app-marketing":{
            "title":"App marketing"
          },
          "business-consulting":{
            "title":"Business consulting"
          }
        }
      },
      "branding":{
        "title":"Branding",
        "desc":"Developing unique identity systems that stick in minds, tell stories and distinguish your business.",
        "url":"/services/branding",
        "subs":{
          "brand-management":{
            "title":"Brand management"
          },
          "brand-identity-design":{
            "title":"Brand identity design"
          },
          "logo-design":{
            "title":"Logo design"
          },
          "rebranding":{
            "title":"Rebranding"
          },
          "brand-activation":{
            "title":"Brand activation"
          },
          "naming":{
            "title":"Naming"
          },
          "art-direction":{
            "title":"Art direction"
          },
          "brand-consulting":{
            "title":"Brand consulting"
          },
          "interior-design":{
            "title":"Interior design"
          }
        }
      },
      "interaction":{
        "title":"Interaction",
        "desc":"Creating user-centred interfaces and design systems that combine aesthetic with good user experience",
        "url":"/services/interaction",
        "subs":{
          "app-design":{
            "title":"App design"
          },
          "web-design":{
            "title":"Web design"
          },
          "user-interface":{
            "title":"User interface"
          },
          "usability":{
            "title":"Usability"
          },
          "user-experience":{
            "title":"User experience"
          },
          "design-systems":{
            "title":"Design systems"
          },
          "user-experience-consulting":{
            "title":"UX consulting"
          }
        }
      },
      "development":{
        "title":"Development",
        "desc":"Web, mobile and desktop solutions backed with security and support to help you kick start your online presence.",
        "url":"/services/development",
        "subs":{
          "saas":{
            "title":"Saas solutions",
            "url":"/solutions/saas"
          },
          "web-apps":{
            "title":"Web Apps",
            "url":"/solutions/web-apps"
          },
          "mobile-apps":{
            "title":"Mobile Apps",
            "url":"/solutions/mobile-apps"
          },
          "desktop-apps":{
            "title":"Desktop Apps",
            "url":"/solutions/desktop-apps"
          }
        }
      },
      "advertising":{
        "title":"Advertising",
        "desc":"Creating strategic campaigns to spread the word about your offerings, products and services a conversion-rate-optimization every medium.",
        "url":"/services/advertising",
        "subs":{
          "graphic-design":{
            "title":"Graphic design"
          },
          "videography":{
            "title":"Videography"
          },
          "photography":{
            "title":"Photography"
          },
          "animation":{
            "title":"Animation"
          },
          "motion":{
            "title":"Motion graphics"
          },
          "3d-production":{
            "title":"3D production"
          }
        }
      },
      "technology":{
        "title":"Technology",
        "desc":"Next-gen solutions to unlock new possibilities for your business and facilitate your daily activities.",
        "url":"/services/technology",
        "subs":{
          "internet-of-things":{
            "title":"Internet of things"
          },
          "robotics-and-automation":{
            "title":"Robotics and automation"
          },
          "artificial-intelligence":{
            "title":"AI"
          },
          "big-data-and-analytics":{
            "title":"Big data and analytics"
          },
          "extended-reality":{
            "title":"Extended reality"
          },
          "technology-consulting":{
            "title":"Technology consulting"
          },
          "security":{
            "title":"Security"
          },
          "devops":{
            "title":"DevOps"
          },
          "testing":{
            "title":"Testing"
          }
        }
      },
      "product-design":{
        "title":"Product design",
        "desc":"Creating simple products and systems that follow a human centered approach and meet the conceptual model of end users.",
        "url":"/services/product-design",
        "subs":{
          "industrial-design":{
            "title":"Industrial design"
          }
        }
      },
      "type-design":{
        "title":"Type design",
        "desc":"Highly customized and exclusive fonts that come in all weights and sizes to express your business.",
        "url":"/services/type-design",
        "subs":{
          "editorial-design":{
            "title":"Editorial design"
          },
          "calligraphy":{
            "title":"Calligraphy"
          }
        }
      }


    },
    "exploreMantra":"Explore by further |categories.",
    "exploreIndustries":"Industries",
    "explorePlatforms":"Platforms",
    "exploreSolutions":"Solutions",
    "cta":"Let's have <br> Coffee togther."

  },
  "ar": {
    "pageTitle":"خدمات بيانات",
    "pageDesc":"نساعد الشركات من خلال خدماتنا التي تشمل العلامة التجارية والتصميم التفاعلي وتصميم الخطوط والأعمال التجارية والرسوم المتحركة والبرمجة وتصميم المنتجات والتكنولوجيا.",
    "mantra":"نبتكر من أجل |نجاح أعمالك.",
    "services":{
      "business":{
        "title":"الأعمال التجارية",
        "desc":"نساعدك على إنشاء أساس متين لعملك التجاري والتغلب على المخاطر، والتخطيط لجميع جهودك التسويقية من خلال استراتيجية قوية.",
        "url":"/services/business",
        "subs":{
          "business-model-innovation":{
            "title":"ابتكار نماذج الأعمال"
          },
          "growth":{
            "title":"استراتيجيات النمو"
          },
          "organization-design":{
            "title":"تخطيط الشركات والمؤسسات،"
          },
          "conversion-rate-optimization":{
            "title":"تحسين معدل التحويل،"
          },
          "marketing":{
            "title":"التسويق"
          },
          "social-media":{
            "title":"استراتيجيات التواصل الإجتماعي"
          },
          "content-creation":{
            "title":"كتابة وإنشاء المحتوى"
          },
          "search-engine-optimization":{
            "title":"تحسين محركات البحث"
          },
          "app-marketing":{
            "title":"تسويق التطبيقات"
          },
          "business-consulting":{
            "title":"استشارات الأعمال التجارية"
          }
        }
      },
      "branding":{
        "title":"تصميم العلامة التجارية",
        "desc":"نصمم علامتك على أساس استراتيجي؛ لتوصل رسالتك وتعكس ما يهدف إليه عملك التجاري وتميزك عن غيرك من المنافسين وفي نفس الوقت تتمتع بمظهر جذاب.",
        "url":"/services/branding",
        "subs":{
          "brand-management":{
            "title":"إدارة العلامات التجارية"
          },
          "brand-identity-design":{
            "title":"تصميم الهوية التجارية"
          },
          "logo-design":{
            "title":"تصميم الشعارات"
          },
          "rebranding":{
            "title":"إعادة تصميم العلامة التجارية"
          },
          "brand-activation":{
            "title":"تفعيل العلامة التجارية"
          },
          "naming":{
            "title":"تسمية العلامة التجارية"
          },
          "art-direction":{
            "title":"استشارات الهوية التجارية"
          },
          "brand-consulting":{
            "title":"الاتجاهات الفنية"
          },
          "interior-design":{
            "title":"التصميم الداخلي"
          }
        }
      },
      "interaction":{
        "title":"التصميم التفاعلي",
        "desc":"نعمل على إنشاء واجهات تتمحور حول المستخدم وأنظمة تصميم تجمع بين المظهر الجمالي وتجربة المستخدم الفعالة.",
        "url":"/services/interaction",
        "subs":{
          "app-design":{
            "title":"تصميم التطبيقات"
          },
          "web-design":{
            "title":"تصميم المواقع"
          },
          "user-interface":{
            "title":"واجهة المستخدم"
          },
          "usability":{
            "title":"قابلية الاستخدام"
          },
          "user-experience":{
            "title":"تجربة المستخدم"
          },
          "design-systems":{
            "title":"أنظمة التصميم"
          },
          "user-experience-consulting":{
            "title":"استشارات تجربة المستخدم"
          }
        }
      },
      "development":{
        "title":"البرمجة",
        "desc":"نقدم لك حلول الويب والجوال وسطح المكتب مدعومة بالأمان لمساعدتك على بدء تواجدك عبر الإنترنت.",
        "url":"/services/development",
        "subs":{
          "saas":{
            "title":"حلول ساس",
            "url":"/solutions/saas"
          },
          "web-apps":{
            "title":"تطبيقات الويب",
            "url":"/solutions/web-apps"
          },
          "mobile-apps":{
            "title":"تطبيقات الجوال",
            "url":"/solutions/mobile-apps"
          },
          "desktop-apps":{
            "title":"تطبيقات سطح المكتب",
            "url":"/solutions/desktop-apps"
          }
        }
      },
      "advertising":{
        "title":"تصميم وإنشاء الإعلانات",
        "desc":"نصمم حملات إعلانية استراتيجية قائمة على فهم عملائك؛ لتقديم الرسالة المناسبة حول المنتجات والخدمات التي تقدمها عبر جميع القنوات.",
        "url":"/services/advertising",
        "subs":{
          "graphic-design":{
            "title":"تصميم الجرافيك"
          },
          "videography":{
            "title":"التصوير"
          },
          "photography":{
            "title":"الفيديو"
          },
          "animation":{
            "title":"الرسوم المتحركة"
          },
          "motion":{
            "title":"الموشن جرافيك"
          },
          "3d-production":{
            "title":"الإنتاج ثلاثي الابعاد"
          }
        }
      },
   "technology":{
        "title":"التكنولوجيا",
        "desc":"نعتمد على تقنيات الذكاء الاصطناعي و البيانات الضخمة والتحليلات وغيرها؛ لتطوير أعمالك من خلال التقنيات التكنولوجية الحديثة التي تفتح إمكانات جديدة وتسهل أداء عملك.",
        "url":"/services/technology",
        "subs":{
          "internet-of-things":{
            "title":"انترنت الأشياء"
          },
          "robotics-and-automation":{
            "title":"الروبتس والأتمتة"
          },
          "artificial-intelligence":{
            "title":"الذكاء الاصطناعي"
          },
          "big-data-and-analytics":{
            "title":"البيانات الضخمة والتحليلات"
          },
          "extended-reality":{
            "title":"الواقع الممتد"
          },
          "technology-consulting":{
            "title":"استشارات التكنولوجيا"
          },
          "security":{
            "title":"حماية وأمان البرمجيات،"
          },
          "devops":{
            "title":"ديف أوبس"
          },
          "testing":{
            "title":"اختبار البرمجيات"
          }
        }
      },
      "product-design":{
        "title":"تصميم المنتجات",
        "desc":"نعمل على إنشاء منتجات وأنظمة بسيطة تتمحور حول المستخدمين وتصبح مألوفة بالنسبة لهم لتهسل عليهم أداء عملياتهم اليومية.",
        "url":"/services/product-design",
        "subs":{
          "industrial-design":{
            "title":"التصميم الصناعي"
          }
        }
      },
      "type-design":{
        "title":"تصميم الخطوط",
        "desc":"النصوص وسيلتك للتواصل مع عملائك و سرد قصتك، اختار الخطوط المناسبة لك والتي تأتي في جميع الأوزان والأحجام للتعبير عن هويتك.",
        "url":"/services/type-design",
        "subs":{
          "editorial-design":{
            "title":"التصميم التحريري"
          },
          "calligraphy":{
            "title":"الكاليجرافي"
          }
        }
      }
    },
    "exploreMantra":"استكشف المزيد بما |يناسب احتياجات أعمالك.",
    "exploreIndustries":"الصناعات",
    "explorePlatforms":"المنصات",
    "exploreSolutions":"الحلول",
    "cta":"دعنا نتناول القهوة <br> سويًا."
  }
}
</i18n>
